export default __webpack_public_path__ + "static/media/slider-3.b4c720af.jpg";